// extracted by mini-css-extract-plugin
export default {"footer":"v4foU_","wrapperCloseBtn":"Qxc5Pq"};